import React from 'react';
import { HeroVariant53 } from '../components/HeroVariant53';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage53() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1714">
      <Navigation data-id="element-1715" />
      <main data-id="element-1716">
        <HeroVariant53 data-id="element-1717" />
        <WhyUs data-id="element-1718" />
        <Services data-id="element-1719" />
        <FAQ data-id="element-1720" />
        <Testimonials data-id="element-1721" />
        <Consultation data-id="element-1722" />
      </main>
      <Footer data-id="element-1723" />
      <CookieBanner data-id="element-1724" />
      <FloatingContact data-id="element-1725" />
    </div>;
}